var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_1689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(-180 16 16)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0665 7.51647L9.64981 5.09981C9.54981 4.99981 9.50258 4.88314 9.50814 4.74981C9.51369 4.61647 9.56647 4.49981 9.66647 4.39981C9.76647 4.29981 9.88592 4.24981 10.0248 4.24981C10.1637 4.24981 10.2831 4.29981 10.3831 4.39981L13.6498 7.66647C13.7054 7.72203 13.7442 7.77758 13.7665 7.83314C13.7887 7.88869 13.7998 7.94981 13.7998 8.01647C13.7998 8.08314 13.7887 8.14425 13.7665 8.19981C13.7442 8.25536 13.7054 8.31092 13.6498 8.36647L10.3665 11.6498C10.2665 11.7498 10.147 11.7998 10.0081 11.7998C9.86925 11.7998 9.74981 11.7498 9.64981 11.6498C9.54981 11.5498 9.49981 11.4304 9.49981 11.2915C9.49981 11.1526 9.54981 11.0331 9.64981 10.9331L12.0665 8.51647L2.49981 8.51647C2.35536 8.51647 2.23592 8.46925 2.14147 8.37481C2.04703 8.28036 1.99981 8.16092 1.99981 8.01647C1.99981 7.87203 2.04703 7.75258 2.14147 7.65814C2.23592 7.56369 2.35536 7.51647 2.49981 7.51647L12.0665 7.51647Z",
    fill: "#3A3A3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.dcd42589e7b8e55ea8c0052e4447562f.svg";
export { ForwardRef as ReactComponent };